import React from 'react';

import { useTheme } from '@material-ui/core/styles';

import {
  Avatar,
  Box,
  Checkbox,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from '@material-ui/core';

import PersonIcon from '@material-ui/icons/Person';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LockIcon from '@material-ui/icons/Lock';

const Usertable = ({
  tableData = [],
  handleSelectAll,
  handleSelect,
  selected
}) => {
  const theme = useTheme();

  const isAllSelected =
    tableData.length > 0 && selected.length === tableData.length;

  const logColumns = Array.from(
    new Set(
      tableData.flatMap(row =>
        Object.keys(row).filter(key => key.startsWith('log'))
      )
    )
  ).sort((a, b) => {
    const aNum = Number(a.replace('log', ''));
    const bNum = Number(b.replace('log', ''));

    return aNum - bNum;
  });

  const formatTime = value => {
    if (!value) return '--';

    try {
      return new Date(value).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch {
      return value;
    }
  };

  return (
    <>
      <Box mb={3} textAlign="center">
        <Typography
          variant="h5"
          style={{
            fontWeight: 700,
            color: theme.palette.text.primary
          }}
        >
          Employee Table
        </Typography>

        <Typography
          variant="body2"
          style={{
            color: theme.palette.text.secondary,
            marginTop: 6
          }}
        >
          View and manage your employees
        </Typography>
      </Box>

      <Paper
        elevation={0}
        style={{
          borderRadius: 20,
          overflow: 'hidden',
          border: `1px solid ${theme.palette.divider}`,
          background: theme.palette.background.paper
        }}
      >
        <Box
          px={3}
          py={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{
            background: `linear-gradient(
              135deg,
              ${theme.palette.primary.dark} 0%,
              ${theme.palette.primary.main} 50%,
              ${theme.palette.primary.light} 100%
            )`,
            color: theme.palette.primary.contrastText
          }}
        >
          <Box>
            <Typography
              variant="h6"
              style={{
                fontWeight: 700
              }}
            >
              Employee Monitoring
            </Typography>

            <Typography
              variant="body2"
              style={{
                opacity: 0.85
              }}
            >
              AI biometric attendance logs
            </Typography>
          </Box>

          <Chip
            label={`${tableData.length} Employees`}
            style={{
              background: 'rgba(255,255,255,0.15)',
              color: theme.palette.primary.contrastText,
              fontWeight: 600
            }}
          />
        </Box>

        <TableContainer
          style={{
            maxHeight: 600,
            background: theme.palette.background.paper
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  padding="checkbox"
                  style={{
                    background: theme.palette.background.default,
                    fontWeight: 700,
                    borderBottom: `1px solid ${theme.palette.divider}`
                  }}
                >
                  {/* <Checkbox
                    color="primary"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  /> */}
                </TableCell>

                <TableCell
                  style={{
                    background: theme.palette.background.default,
                    fontWeight: 700,
                    borderBottom: `1px solid ${theme.palette.divider}`
                  }}
                >
                  EMPLOYEE
                </TableCell>

                {/* {logColumns.map(log => (
                  <TableCell
                    key={log}
                    align="center"
                    style={{
                      background: theme.palette.background.default,
                      fontWeight: 700,
                      minWidth: 120,
                      borderBottom: `1px solid ${theme.palette.divider}`
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      gridGap={6}
                    >
                      <AccessTimeIcon
                        style={{
                          fontSize: 16,
                          color: theme.palette.primary.main
                        }}
                      />

                      {log.toUpperCase()}
                    </Box>
                  </TableCell>
                ))} */}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => {
                  const isChecked = selected.includes(row.ixSub);
                  const hasNoImages = !row.hasFaceImages;

                  return (
                    <TableRow
                      key={row.ixSub}
                      hover={!hasNoImages}
                      selected={isChecked}
                      onClick={() => !hasNoImages && handleSelect(row.ixSub)}
                      style={{
                        transition: '0.2s',
                        background:
                          index % 2 === 0
                            ? theme.palette.background.paper
                            : theme.palette.action.hover,
                        opacity: hasNoImages ? 0.5 : 1
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Tooltip title={hasNoImages ? 'No face images registered. Please register first.' : ''}>
                          <Checkbox
                            color="primary"
                            checked={isChecked}
                            disabled={hasNoImages}
                            onClick={e => e.stopPropagation()}
                            onChange={() => handleSelect(row.ixSub)}
                          />
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Avatar
                            style={{
                              width: 38,
                              height: 38,
                              marginRight: 12,
                              background: hasNoImages
                                ? theme.palette.grey[400]
                                : `linear-gradient(
                                  135deg,
                                  ${theme.palette.secondary.main} 0%,
                                  ${theme.palette.primary.main} 100%
                                )`
                            }}
                          >
                            {hasNoImages ? <LockIcon /> : <PersonIcon />}
                          </Avatar>

                          <Box>
                            <Typography
                              variant="body2"
                              style={{
                                fontWeight: 700,
                                color: theme.palette.text.primary
                              }}
                            >
                              {row.sEmp}
                            </Typography>

                            <Typography
                              variant="caption"
                              style={{
                                color: theme.palette.text.secondary
                              }}
                            >
                              {row.sSub}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      {/* {logColumns.map(log => (
                        <TableCell key={log} align="center">
                          {row[log] ? (
                            <Chip
                              label={formatTime(row[log])}
                              size="small"
                              style={{
                                background: theme.palette.primary.main + '20',
                                color: theme.palette.primary.main,
                                fontWeight: 600
                              }}
                            />
                          ) : (
                            <Typography
                              variant="caption"
                              style={{
                                color: theme.palette.text.disabled
                              }}
                            >
                              --
                            </Typography>
                          )}
                        </TableCell>
                      ))} */}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={logColumns.length + 2}
                    align="center"
                    style={{
                      padding: 40
                    }}
                  >
                    <Typography
                      variant="body1"
                      style={{
                        color: theme.palette.text.secondary
                      }}
                    >
                      No Employee Data Found
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default Usertable;
